<template>
  <div class="privacy-policy">
    <p>版本更新日期：2025年9月1日</p>
    <p>版本生效日期：2025年9月1日</p>
    <p class="em">
      日立电梯（中国）有限公司（以下简称“日立电梯”）是日立电梯数字服务平台的运营者，本《隐私政策》（以下简称“本政策”）阐述了日立电梯将如何收集、使用、保存、共享、转让和公开披露您（以下称“用户”）的个人信息和隐私信息，并申明了日立电梯对保护隐私的承诺，日立电梯未来有可能根据信息处理情境不时更新或修改本政策。
    </p>
    <h3>本政策将帮助用户了解以下内容：</h3>
    <ul class="em">
      <li>一、如何收集和使用用户的个人信息</li>
      <li>二、如何使用Cookies和同类技术</li>
      <li>三、如何共享、转让、公开披露用户的个人信息</li>
      <li>四、如何保护和保存用户的个人信息</li>
      <li>五、用户的权利</li>
      <li>六、如何处理未成年人的个人信息</li>
      <li>七、本政策如何更新</li>
      <li>八、联系日立电梯</li>
    </ul>
    <p class="em">
      请用户在向日立电梯提交个人信息或隐私信息之前，充分阅读、了解并同意本政策和任何补充政策。本政策中涉及的相关术语，日立电梯尽量以简明扼要的方式进行表述，以便用户更好地理解。<span
        class="bold"
        >用户使用或在日立电梯更新本政策后（日立电梯会及时提示用户更新的情况）继续使用日立电梯的服务，即意味着用户同意本政策(含更新版本)内容，并且同意日立电梯按照本政策收集、使用、储存、共享、转让和公开披露用户的相关信息。</span
      >
    </p>
    <h3 class="bold">一、如何收集和使用用户的个人信息</h3>
    <p class="em">
      在本隐私政策中，“个人信息”指通过信息本身或通过关联其他信息后能够识别特定个人的数据。此类个人信息包括但不限于用户主动提供给日立电梯的信息，日立电梯系统指定与用户相关的信息，以及根据用户所使用的服务，相应收集的信息，可能包括姓名信息，位置信息，登录日志信息，使用日志信息等。
    </p>
    <p class="bold">1、日立电梯如何处理用户个人信息</p>
    <ul>
      <li>
        <p class="bold em">1.1帮助用户完成注册及登录：</p>
        <p class="bold em">
          为了向用户提供服务、保障服务的正常运行以及保障账号安全，用户需要提供基本注册和登录信息：姓名、真实有效的手机号码、用户名、密码、楼宇信息，且出于安全和防欺诈的目的，在用户授权的前提下，通过合法来源核实用户的信息（认证时电话号码与短信验证码）；
        </p>
        <p class="bold em">
          用户亦可选择使用日立电梯支持的第三方平台账号进行登录（例如当用户使用微信账户绑定日立电梯服务时），包括：从第三方社交网络服务中获取某些信息，包括：昵称、头像、性别、OPEN
          ID、国家、省份、城市、语言；他人提供的与用户有关的信息，当他人邀请或授权用户使用日立电梯服务时，包括：姓名、手机号码、用户类型。
        </p>
      </li>
      <li>
        <p class="bold em">1.2基于地理位置的功能及服务</p>
        <p class="em">
          如用户使用“智慧乘梯”等功能时，日立电梯可能会收集和处理有关用户的设备信息位置信息。位置信息包括通过GNSS信息，WLAN接入点、蓝牙、基站所获取的精确位置信息，也包括通过IP地址或其他网络信息获取的粗略地理位置信息。我们会请求精确地理位置权限授权，您可以拒绝授权精确地理位置权限，或随时通过取消系统授权我们访问用户的精确位置信息，停止我们对用户的精确地理位置信息的收集，之后用户可能将无法使用上述基于精确位置信息提供的基本功能服务，或者无法达到上述基于精确位置信息提供的基本功能服务拟达到的效果。
        </p>
      </li>
      <li>
        <p class="bold em">1.3维护正常运行</p>
        <p class="em">
          <span class="bold">登录日志信息和使用记录信息：</span
          >在提供、处理、维护、改善、开发日立电梯的产品或提供给用户的服务过程中，为识别账号异常状态、了解产品适配性，以保障应用、服务正常运行，优化服务体验，日立电梯会直接或间接地收集，存储关于用户使用的服务以及使用方式的信息并将这些信息进行关联，包括：登录日志信息、使用记录信息：Cookie
          和其他匿名标识符技术、IP
          地址、网络请求信息、临时消息历史、标准系统日志、错误崩溃信息；
        </p>
        <p class="em">
          <span class="bold">设备信息：</span
          >日立电梯会根据用户在使用产品时的具体操作，接收并记录用户所使用的设备相关信息（包括设备型号、操作系统版本、设备设置及设备序列号IMEI、IDFA、OAID、设备MAC地址、IMSI、AndroidID、设备环境软硬件特征信息），设备所在位置相关信息（包括Lbs、GPS位置信息、WLAN接入点、蓝牙和基站传感器信息）。
        </p>
      </li>
      <li>
        <p class="bold em">1.4使用“人脸召梯”功能</p>
        <p class="em">
          为提高用户使用召梯功能的便利性，日立电梯提供“人脸召梯”功能。如用户选择使用该项功能的，用户登陆小程序后，在小程序上上传照片作为识别的依据。日立电梯需要用户授权访问设备相机权限、存储权限，并收集用户上传、拍摄的图片信息，其中可能包含敏感个人信息。
        </p>
        <p class="em">
          前述功能并非强制开通，如用户拒绝提供相关授权或图片的，将导致用户无法正常使用前述功能，但不会影响用户正常使用其他功能。
        </p>
      </li>
    </ul>
    <p>2、非个人信息</p>
    <p class="em">
      日立电梯还可能收集其他无法识别到特定个人、根据当地适用法律不属于个人信息的信息，例如用户使用特定服务时产生的统计类数据，如匿名设备相关信息、日活事件、页面访问事件、页面访问时长事件、会话事件；网络监控数据如请求时长、请求与错误请求数等；以及应用崩溃事件。收集此类信息的目的在于改善日立电梯向用户提供的服务。所收集信息的类别和数量取决于用户如何使用日立电梯产品或服务。
    </p>
    <h3 class="bold">二、如何使用Cookies和同类技术</h3>
    <p class="em">
      用户使用日立电梯的服务时，日立电梯可能会在用户的计算机或移动设备上存储名为<span
        class="bold"
        >Cookies</span
      >的小数据文件。<span class="bold">Cookies</span
      >通常包含标识符、站点名称以及一些号码和字符。日立电梯可能会使用该等信息判断注册用户是否已经登录，提升服务质量及优化用户体验。
    </p>
    <p class="em">
      <span class="bold dline"
        >日立电梯不会将Cookies用于本政策所述目的之外的任何用途</span
      >。用户可根据自己的偏好管理或删除<span class="bold">Cookies</span
      >。用户可以清除计算机上保存的所有<span class="bold">Cookies</span
      >，大部分网络浏览器都设有阻止<span class="bold">Cookies</span
      >的功能。但如果用户这么做，用户可能需要在每一次访问日立电梯的网站时亲自更改用户设置，而且用户之前所记录的相应信息也均会被删除，并且可能会对用户所使用服务的安全性有一定影响。
    </p>
    <h3 class="bold">三、如何共享、转让、公开披露用户的个人信息</h3>
    <p class="bold em">1、共享</p>
    <p class="em">
      <span class="bold dline"
        >日立电梯不会在未经用户同意或授权的情况下向任何公司、组织和个人分享用户的个人信息</span
      >，特别个人生物识别信息，但是经用户同意后，日立电梯可在以下情况下共享用户个人信息：
    </p>
    <ul class="em">
      <li>
        1）在获取明确同意的情况下共享：获得用户的明确同意后，日立电梯会与其他方共享用户的个人信息。
      </li>
      <li>
        2）日立电梯可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享用户的个人信息。
      </li>
      <li>
        3）与日立电梯的关联公司共享：为向用户提供商品或服务（智慧乘梯、信息同步查询、系统更新）等功能，完成小程序/APP身份认证流程，用户的姓名、手机号码将会通过内部API接口传输共享至日立电梯（中国）有限公司。关联公司如要改变个人信息的处理目的，需再次征求用户的单独授权同意。
      </li>
      <li>
        4）为保障我们客户端的稳定运行和功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入第三方的SDK或其他类似的应用程序。
      </li>
    </ul>
    <p class="em">您可查看我们接入的SDK详情：</p>
    <p class="em">1、第三方SDK名称：微信Open SDK</p>
    <p class="em">第三方公司名称：深圳市腾讯计算机系统有限公司。</p>
    <p class="em">
      使用目的：为用户提供跳转打开日立电梯BIVALE系统微信小程序的功能。
    </p>
    <p class="em">
      收集个人信息类型：设备信息(OAID、IDFV操作系统信息、设备型号信息)。
    </p>
    <p class="em">隐私政策链接：微信Open SDK。</p>
    <p class="bold em">2、转让</p>
    <p class="em">
      日立电梯不会将用户的个人信息转让给任何公司、组织和个人，但以下情况除外：
    </p>
    <ul class="em">
      <li>
        1）在获取明确同意的情况下转让：获得用户的明确同意后，日立电梯会向其他方转让用户的个人信息；
      </li>
      <li>
        2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，日立电梯会要求新的持有用户个人信息的公司、组织继续受本政策的约束，否则日立电梯将要求该公司、组织重新向用户征求授权同意。
      </li>
    </ul>
    <p class="bold em">3、公开披露</p>
    <p class="em">日立电梯仅会在以下情况下，公开披露用户的个人信息：</p>
    <ul class="em">
      <li>1）获得用户明确同意后；</li>
      <li>
        2）基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，日立电梯可能会公开披露用户的个人信息。
      </li>
    </ul>
    <h3 class="bold">四、如何保护和保存您的个人信息</h3>
    <p class="bold">1、保护用户个人信息的技术与措施</p>
    <ul class="em">
      <li>
        1）日立电梯十分重视个人信息的安全。日立电梯采取业内标准做法来保护用户的个人信息，防止信息遭到未经授权的访问、披露、使用、修改、损坏或丢失。日立电梯会采取一切合理可行的措施，保护用户的个人信息。例如，日立电梯的网络服务采取了传输层安全协议等加密技术，通过https等方式提供通信服务，确保用户信息在传输过程中的安全；日立电梯通过采取加密技术对用户个人信息进行加密保存，且日立电梯对用户个人敏感信息的保存和传输均采取强加密算法的单向哈希，同时会对加密算法进行加密保护，并对保存和传输的个人敏感信息的环境定期进行病毒查杀以及系统漏洞扫描检测。
      </li>
      <li>
        2）日立电梯会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
      </li>
      <li>
        3）日立电梯仅允许有必要知晓这些信息的日立电梯的员工访问个人信息，并为此设置了严格的访问权限控制和监控机制。日立电梯同时要求可能接触到用户个人信息的人员履行相应的保密义务，如果未能履行这些义务，可能会被追究法律责任。
      </li>
      <li>
        4）日立电梯会采取一切合理可行的措施，确保未收集与日立电梯提供的服务无关的个人信息。
      </li>
      <li>
        5）日立电梯会尽全力保护用户的个人信息，但请用户理解，<span class="bold"
          >由于技术的限制以及可能存在的各种恶意手段，在互联网不可能始终保证信息百分之百的安全。用户需要了解，用户接入日立电梯的服务所用的系统和通讯网络，有可能因日立电梯可控范围外的因素而出现问题。</span
        >
      </li>
      <li>
        6）在发生个人信息安全事件时，日立电梯将按照法律法规的要求，及时向用户告知：安全事件的基本情况和可能的影响、日立电梯已采取或将要采取的处置措施、用户可自主防范和降低风险的建议、对用户的补救措施等。日立电梯将及时将事件相关情况以电话、推送通知等方式告知用户，难以逐一告知个人信息主体时，日立电梯会采取合理、有效的方式发布公告。同时，日立电梯还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      </li>
    </ul>
    <p class="bold">2、如何保存用户的个人信息</p>
    <p class="em">
      日立电梯在中华人民共和国境内运营中收集和产生的个人信息，储存在中国境内，以下情形除外：
    </p>
    <ul>
      <li>1）法律法规有明确规定；</li>
      <li>2）获得用户的授权同意；</li>
    </ul>
    <p class="em">针对以上情形，日立电梯会确保依据本政策及国家法律法规要求对用户的个人信息提供足够的保护。</p>
    <p class="em">日立电梯仅会在达到本政策所述目的所必需的时限内保存用户的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，日立电梯可能会将个人信息保存时间予以适当延长。</p>
    <h3 class="bold">五、用户的权利</h3>
    <p class="em">
      日立电梯非常重视用户对个人信息的关注，并尽全力保护用户对于个人信息访问、更正、删除以及注销账号的权利，以使用户拥有充分的能力保障用户的隐私和安全。用户的权利包括：
    </p>
    <ul class="em">
      <li>
        1、用户可以按照日立的相关政策及平台页面提示，通过“个人中心”或“我的”页面等相关功能对用户的个人信息进行访问、更正及删除；具体权限及方式以平台相关页面显示的操作要求及信息为准。同时，日立电梯将尽一切可能采取适当的技术手段，保证收集到的有关于用户的个人信息的准确性，并保证及时进行更新。
      </li>
      <li>
        2、日立电梯尊重用户的个人选择权。
        <p>
          用户可以按照日立电梯的相关政策及平台页面提示进行隐私设置，具体设置路径以平台相关页面显示的操作要求及信息为准。
        </p>
      </li>
      <li>
        3、解除账户绑定。
        <p>
          用户可解除认证的平台账户绑定关系，具体解除路径以平台相关页面显示的操作要求及信息为准。关于用户解除账户应满足的条件及解除账户对用户的影响，请详见相关提示页面。
        </p>
      </li>
      <li>
        4、删除账户信息
        <p>
          如需彻底删除个人信息，用户需联系管理员操作处理，通常用户信息由用户所属企业/组织/社区管理员删除，如用户在联系上述管理员处理存在困难时，可通过联系日立电梯处理，日立电梯将在15个工作日内处理完成。
        </p>
      </li>
      <li>
        5、响应用户的请求
        <p>
          如果用户无法通过上述方式访问、更正或删除个人信息，或用户需要访问、更正或删除用户在使用日立电梯服务时所产生的其他个人信息，或用户认为我们存在任何违反法律法规或与用户关于个人信息的收集使用的约定，用户均可以通过平台的“意见反馈”与日立电梯联系。为了保障安全，日立电梯可能需要用户提供书面请求，或以其他方式证明用户的身份，日立电梯将在收到用户反馈并验证用户的身份后的15天内答复用户的请求。对于用户合理的请求，日立电梯原则上不收取费用，但对多次重复、超出合理限度的请求，日立电梯将视情形收取一定成本费用。对于那些无端重复、需要过多技术手段（例如需要开发新系统或从根本上改变现行惯例等）、给他人合法权益带来风险或者非常不切实际的请求，日立电梯可能会予以拒绝。
        </p>
      </li>
    </ul>
    <p>在以下情形中，按照法律法规要求，日立电梯将无法响应用户的请求：</p>
    <ul class="em">
      <li>（1）与国家安全、国防安全直接相关的；</li>
      <li>（2）与公共安全、公共卫生、重大公共利益直接相关的；</li>
      <li>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
      <li>（4）有充分证据表明用户存在主观恶意或滥用权利的；</li>
      <li>
        （5）响应用户的请求将导致用户或其他个人、组织的合法权益受到严重损害的；
      </li>
      <li>（6）涉及商业秘密的。</li>
    </ul>
    <h3 class="bold">六、如何处理未成年人的个人信息</h3>
    <p class="em">
      未满十八周岁的未成年人使用日立电梯的服务需父母或监护人同意及指导。日立电梯建议未成年人的父母或监护人阅读本政策，并要求提交未成年人个人信息之前需经过其父母或监护人的同意。日立电梯将根据国家相关法律法规的规定保护未成年人的相关信息。
    </p>
    <h3 class="bold">七、本政策如何更新及适用范围</h3>
    <p class="em">
      本政策为《日立电梯（中国）有限公司微信平台服务协议》的重要组成部分。日立电梯保留不时更新或修改本政策的权利，日立电梯会在平台页面上发布对本政策所做的任何变更。对于重大变更，日立电梯还会提供更为显著的通知，说明隐私政策的具体变更内容。渠道向用户发送变更通知，包括但不限于网站公示、私信通知、电子邮件通知等方式。
    </p>
    <p class="em">本政策所指的重大变更包括但不限于：</p>
    <ul class="em">
      <li>
        1）日立电梯的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
      </li>
      <li>
        2）日立电梯在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
      </li>
      <li>3）个人信息共享、转让或公开披露的主要对象发生变化；</li>
      <li>4）用户参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
      <li>
        5）日立电梯负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
      </li>
      <li>6）个人信息安全影响评估报告表明存在高风险时。</li>
    </ul>
    <p class="em bold">
      若用户不同意修改后的隐私政策，用户应立即停止使用日立电梯的服务。如果用户继续使用日立电梯的服务，则视为用户接受日立电梯对本政策相关条款所做的修改。
    </p>
    <p class="em">
      日立电梯的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明日立电梯在该服务中如何处理用户的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。
    </p>
    <h3 class="bold">八、联系日立电梯</h3>
    <p class="em">
      当用户对本政策有任何疑问，可以通过点击平台的“意见反馈”进行咨询，日立电梯将及时解决用户的问题。
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy",
  props: {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.privacy-policy {
  border: 1px solid #ccc;
  height: 390px;
  overflow-y: auto;
  padding: 10px;
  .bold {
    font-weight: bold;
  }
  .em {
    text-indent: 2em;
  }
  .dline {
    text-decoration: underline;
  }
}
</style>
